<script setup>
import '@/styles/css/privacy-policy.scss'
import '@/styles/css/blog-page.scss'
import { onMounted } from 'vue';
onMounted(()=>{
      $(".accordian-content").hide(),
      $(".policy-accordian h3").click((function() {
          $(this).toggleClass("active").next(".accordian-content").slideToggle(350).closest("li").siblings().find("h3").removeClass("active").next(".accordian-content").slideUp(350),
          $(this).toggleClass("active").find("i").toggleClass("fa-plus fa-minus").closest("li").siblings().removeClass("active").find("i").removeClass("fa-minus").addClass("fa-plus")
      }
      ))
})
</script>
<template>
  <div class="page-container">
    <!--banner-->
    <section class="privacy-policy-banner banner-inner">
      <div class="heading">
        <h1
          class="wow fadeInDown animated"
          data-wow-duration="1s"
          style="visibility: visible; animation-duration: 1s"
        >
          Terms of Use and Privacy Policy
        </h1>
        <!-- <p>
               For those of us who don't have time to track the stock market
            </p> -->
      </div>
    </section>
    <!--/banner-->

    <!--privacy polocy-->
    <section class="privacy-policy">
      <!--container-->
      <div class="container">
        <!--privacy policy description-->
        <div class="privacy-description">
          <b>Last Updated: 21st Jan 2025</b>
          <p class="subheading">Terms &amp; Condition:</p>

          <p>
            Welcome to Upstox! By browsing or using our platform—whether through
            our website or mobile application—you agree to comply with and be
            bound by our terms and conditions of use. These, along with our
            privacy policy, govern your relationship with Upstox and our
            platform(s).
          </p>

          <p>
            Upstox refers to RKSV Securities India Private Limited (CIN:
            U74900DL2009PTC189166), Upstox Securities Private Limited (CIN:
            U65100DL2021PTC376860), and RKSV Commodities India Private Limited
            (CIN: U65190DL2012PTC236371), along with its affiliates, associated
            companies, and subsidiaries. These entities will collectively be
            referred to as 'Company', 'we', 'us', or 'our'. At Upstox, we are
            committed to respecting your privacy and preferences. This Privacy
            Statement (referred to as the “Statement”) outlines our privacy
            practices regarding the collection and processing of personal
            information, in line with applicable data privacy regulations.
          </p>

          <p>
            The term 'Upstox' or 'us' or 'we' refers to the owner of the website
            whose registered office is 807, New Delhi House, Barakhamba Road,
            Connaught Place, New Delhi – 110001 and corporate office at 30th
            Floor, Sunshine Tower, Senapati Bapat Marg, Dadar (West), Mumbai -
            400013. The term 'you' refers to the user or viewer of our website.
          </p>

          <p>
            The use of this website/application is subject to the following
            terms of use:
          </p>
          <ul class="termsPoints">
            <li>
              The content of the pages of this website/application is for your
              general information and use only. It is subject to change without
              notice.
            </li>
            <li>
              Neither we nor any third parties provide any warranty or guarantee
              as to the accuracy, timeliness, performance, completeness or
              suitability of the information and materials found or offered on
              this website/application for any particular purpose. You
              acknowledge that such information and materials may contain
              inaccuracies or errors and we expressly exclude liability for any
              such inaccuracies or errors to the fullest extent permitted by
              law.
            </li>
            <li>
              Your use of any information or materials on this
              website/application is entirely at your own risk, for which we
              shall not be liable. It shall be your responsibility to ensure
              that any products, services or information available through this
              website/application meet your specific requirements.
            </li>
            <li>
              This website/application contains material which is owned by or
              licensed to us. This material includes, but is not limited to, the
              design, layout, look, appearance and graphics. Reproduction is
              prohibited other than in accordance with the copyright notice,
              which forms part of these terms and conditions.
            </li>
            <li>
              All trademarks reproduced in this website/application which are
              not the property of, or licensed to, the operator are acknowledged
              on the website/application.
            </li>
            <li>
              Unauthorised use of this website/application may give rise to a
              claim for damages and/or be a criminal offence.
            </li>
            <li>
              From time to time this website/application may also include links
              to other websites/applications. These links are provided for your
              convenience to provide further information. They do not signify
              that we endorse the website(s)/application(s). We have no
              responsibility for the content of the linked website(s).
            </li>
            <li>
              You may not create a link to this website/application from another
              website or document without Upstox’s prior written consent.
            </li>
            <li>
              Your use of this website/application and any dispute arising out
              of such use of the website/application is subject to the laws of
              India or other regulatory authority.
            </li>
          </ul>
          <p>
            We as a merchant shall be under no liability whatsoever in respect
            of any loss or damage arising directly or indirectly out of the
            decline of authorisation for any Transaction, on Account of the
            Cardholder having exceeded the preset limit mutually agreed by us
            with our acquiring bank from time to time
          </p>
        </div>
        <!--/privacy policy description-->

        <!--privacy-policy accrordian-->
        <div class="policy-accordian">
          <ol>
            <li>
              <h3>Privacy Policy: <i class="fa fa-plus"></i></h3>
              <div class="accordian-content" style="display: none">
                <p>
                  Upstox includes RKSV Securities India Private Limited (CIN:
                  U74900DL2009PTC189166) or Upstox Securities Private Limited
                  (CIN: U65100DL2021PTC376860) or RKSV Commodities India Private
                  Limited (CIN: U65190DL2012PTC236371), its affiliates,
                  associates Companies, subsidiaries or any Company formed under
                  the group referred to hereafter as 'Company', 'we', 'us', or
                  'our', or Upstox is dedicated to respecting your privacy and
                  preferences. This Privacy Statement (hereinafter referred to
                  as the “Statement”) outlines our privacy practices concerning
                  the Personal Information collected and processed, in
                  accordance with applicable data privacy regulations.
                </p>
                <p>
                  We prioritise privacy and are dedicated to safeguarding
                  personal information. This Privacy Policy details how we
                  collect, use, and protect your data. This policy applies to
                  the website or application. This policy applies to all the
                  products, services, and businesses of Upstox. The terms of
                  this policy may be in addition to the existing terms of the
                  products, services or businesses
                </p>
                <b>Definitions:</b>
                <ul class="termsPoints">
                  <li>
                    "Data" means a representation of information, facts,
                    concepts, opinions or instructions in a manner suitable for
                    communication, interpretation or processing by human beings
                    or by automated means;
                  </li>
                  <li>
                    “Personal data” means any data about an individual who is
                    identifiable by or in relation to such data;
                  </li>
                  <li>
                    “Processing” in relation to personal data, means a wholly or
                    partly automated operation or set of operations performed on
                    digital personal data, and includes operations such as
                    collection, recording, organising, structuring, storage,
                    adaptation, retrieval, use, alignment or combination,
                    indexing, sharing, disclosure by transmission, dissemination
                    or otherwise making available, restriction, erasure or
                    destruction;
                  </li>
                  <li>
                    <b>Data fiduciary:</b> The person or entity that decides how
                    to process personal data.
                  </li>
                  <li>
                    <b>Data processor:</b> The person who processes personal
                    data on behalf of the data fiduciary.
                  </li>
                  <li>
                    <b>Data principal:</b> The individual whose personal data is
                    being processed.
                  </li>
                </ul>
                <b>Collection of Information:</b>
                <p>
                  Upstox may collect Personal Information, Transaction
                  Information, and Non-Personal Information (as defined below)
                  when you register an account or create an account on our
                  Platform or when you use our Services. However, certain areas
                  of the Platform may be accessed without requiring you to
                  create an account or register as a member. Information
                  includes Data from credit information companies/credit
                  reference agencies, risk management and fraud prevention
                  agencies, and national and government databases.
                </p>
                <ul class="termsPoints">
                  <li>
                    We collect and verify location, IP address, and device
                    details (e.g., device type, operating system, IMEI) to
                    confirm residency and meet regulatory requirements.
                    Information, including browser data and unique identifiers,
                    is securely stored, with passwords/PINs encrypted for
                    protection.
                  </li>
                  <li>
                    To utilise features on platforms/ apps by granting us access
                    to Data
                  </li>
                  <li>
                    For system development, planning, audit, and administrative
                    purposes, as well as to personalise and enhance the user
                    experience on the platform or app.
                  </li>
                </ul>
                <b>Information for Processing of Personal Data:</b>
                <ul class="termsPoints">
                  <li>
                    Upstox may collect information such as full name, mobile
                    number, email address, password, date of birth, gender,
                    Permanent Account Number (PAN), signature, marital status,
                    nominee details, residential/current address, any national
                    identifiers such as identity card/passport details/Aadhaar
                    card details/Voter ID/driving license, bank account details
                    or any other personal information as required by the law or
                    for providing you various services.
                  </li>
                  <li>
                    Conversations during
                    meetings/calls/correspondences/discussions with staff.
                  </li>
                  <li>
                    Records of correspondence and other communications with you,
                    including email, telephone conversations, live chat, instant
                    messages and social media communications containing
                    information concerning your grievances, complaints and
                    disputes.
                  </li>
                  <li>
                    Any other information, data, or records which you may
                    consent to be collected or used.
                  </li>
                </ul>
                <b>Use of Your Information</b>
                <p>
                  Upstox may use users' Personal Information for the following
                  purposes:
                </p>
                <ul class="termsPoints">
                  <li>
                    To identify users, create login credentials, and facilitate
                    access to the platform.
                  </li>
                  <li>
                    To enhance user experience, troubleshoot issues, and conduct
                    platform maintenance.
                  </li>
                  <li>
                    To deliver and improve requested services and tailor user
                    experience.
                  </li>
                  <li>
                    To protect data and company assets from security threats,
                    unauthorised access, or data misuse.
                  </li>
                  <li>
                    To support marketing communications and related activities.
                  </li>
                  <li>
                    To enforce terms and conditions and communicate policy
                    updates.
                  </li>
                  <li>
                    To process service requests and respond to user inquiries.
                  </li>
                  <li>
                    To notify users of important updates, platform changes, and
                    policy information.
                  </li>
                  <li>
                    To ensure compliance with applicable laws and regulatory
                    requirements.
                  </li>
                  <li>
                    To provide or refer to the various other products of Upstox
                    and its associate company.
                  </li>
                </ul>

                <b>Processing Personal Information</b>
                <p>
                  The following are obligations of Upstox for data processing
                </p>
                <ul class="termsPoints">
                  <li>
                    Upstox may process user Personal Information to fulfil a
                    contract, support legitimate interests (like platform use
                    and login generation), meet legal obligations, and with user
                    consent when needed.
                  </li>
                  <li>
                    Upstox may process data for offering the products and to
                    manage relations.
                  </li>
                  <li>To contact you and enhance user experience.</li>
                  <li>
                    Upstox may analyse and process user preferences, account
                    activities, and service usage patterns to identify potential
                    areas of interest in its array of financial products and
                    services.
                  </li>
                  <li>
                    While ensuring compliance with applicable laws and
                    regulations, Upstox may leverage such insights to
                    communicate opportunities, promotions, or additional
                    products that may enhance the user's experience.
                  </li>
                </ul>
                <b
                  >Data recipients with whom we disclose User Personal
                  Information</b
                >
                <p>
                  Upstox may be required to share user Personal Information with
                </p>
                <ol class="termsPoints">
                  <li>
                    RKSV Securities India Private Limited, its subsidiaries and
                    associates, Affiliates
                  </li>
                  <li>Business Partners;</li>
                  <li>Service Providers, Vendors, agents;</li>
                  <li>Third-party Agents</li>
                  <li>Auditors;</li>
                </ol>

                <p>
                  We may share your Data, without obtaining your consent or
                  without intimating you: (a) with governmental, statutory,
                  regulatory, executive, law-enforcement, investigating or
                  judicial/ quasi-judicial authorities, departments,
                  instrumentalities, agencies, institutions, boards,
                  commissions, courts, tribunals, who ask for such Data
                  including by way of an order, direction, etc; or (b) with any
                  person, where disclosure is necessary for compliance of any
                  legal or regulatory obligation. Wherever the Data is shared as
                  above, we will not have control over how such Data is further
                  processed by such authorities, persons, etc.
                </p>
                <b>Facilitating International Data Transfers</b>
                <p>
                  Upstox may engage the services of a Cloud Service Provider
                  (CSP), whose data servers might be located outside India. In
                  such cases, there is a possibility that Personally
                  Identifiable Information (PII) could be stored beyond Indian
                  territorial boundaries. This will, however, be in compliance
                  with applicable regulations and prevailing laws.
                </p>
                <p>
                  If it becomes necessary or incidental to transfer data outside
                  a user's country or region of residence, Upstox will take
                  reasonable and appropriate measures to ensure that such
                  transfers are conducted in compliance with applicable laws and
                  regulations, safeguarding the data throughout the process.
                </p>
                <p>
                  Additionally, Upstox may disclose Personal Information to law
                  enforcement or regulatory authorities when necessary to comply
                  with legal obligations.
                </p>
                <p>
                  <b>Data retention </b>
                </p>
                <p>
                  We will comply with all applicable data retention regulations
                  as mandated by regulatory authorities including but not
                  limited to the retention of customer data such as personal,
                  financial, and transactional information for the duration
                  required by relevant laws and regulations to meet legal,
                  audit, and operational needs. Once the retention period
                  expires, we will securely delete or anonymise the data in
                  accordance with industry best practices, unless extended
                  retention is necessary for legitimate business purposes or to
                  fulfill legal obligations.
                </p>
                <p>
                  <b>User Rights</b>
                </p>
                <ol class="termsPoints">
                  <li>
                    Users acknowledge that Upstox has the right to use and
                    process their data in accordance with the consent provided
                    by the user. No action can be taken against Upstox for data
                    transfer or processing conducted within the scope of the
                    user's consent. These rights may include, but are not
                    limited to, the rights to information, access,
                    rectification, erasure, objection, restriction of
                    processing, right to nominate and the right to file a
                    complaint. If the processing of Personal Information is
                    based on the user's consent, the user retains the right to
                    withdraw this consent at any time subject fulfillment of the
                    requirements. It is important to note that the withdrawal of
                    consent will not affect the legality of any data processing
                    conducted prior to the withdrawal. Upstox will ensure that
                    any further processing of Personal Information ceases
                    immediately upon the withdrawal of consent, except where
                    otherwise permitted or required by law.
                  </li>
                  <li>
                    By providing this consent, users empower Upstox to process
                    their data in a transparent and lawful manner, while
                    retaining full control over their rights as data subjects.
                    Upstox remains committed to respecting and protecting these
                    rights in compliance with applicable data protection laws.
                  </li>
                  <li>
                    <b>Exercising rights:</b> To exercise user rights, Upstox
                    may need to request specific information from users to
                    verify their identity and confirm their entitlement to those
                    rights. User can exercise their rights by contacting Upstox
                    at
                    <b>”<a href="mailto:privacy@rksv.in">privacy@rksv.in</a>”</b
                    >.
                  </li>
                </ol>
                <b>Consent Withdrawal</b>
                <p>
                  To withdraw consent for processing your personal data, please
                  email
                  <a href="mailto:privacy@rksv.in">privacy@rksv.in</a> from your
                  registered email ID. The request will be processed within 30
                  business days. Note: Some data may be retained for legal
                  purposes, and withdrawal may affect services provided.
                </p>
                <b>Data Security</b>
                <p>
                  At Upstox, we seamlessly integrate Governance, Process, and
                  Technology, demonstrating our commitment to our customers and
                  stakeholders. We implement appropriate security measures,
                  including administrative, physical, and technical controls, to
                  protect your Personal Information.
                </p>

                <b>How to contact us</b>
                <p>
                  If you have any questions about our privacy practices or this
                  privacy statement, or if you would like to request this
                  statement in a different format, please reach out to us at:
                  <a href="mailto:privacy@rksv.in">privacy@rksv.in</a>
                </p>

                <b>Grievance Redressal</b>
                <p>
                  In case of any queries or grievances related to privacy please
                  contact us at -
                  <a href="mailto:privacy@rksv.in">privacy@rksv.in</a>. The DPO
                  appointed will be the Grievance Officer and can be contacted
                  at <a href="mailto:privacy@rksv.in">privacy@rksv.in</a>
                </p>

                <b>Governing Law &amp; Jurisdiction</b>
                <p>
                  This policy will be governed by and construed in accordance
                  with the laws of India and subjected to the exclusive
                  jurisdiction of the Courts of Mumbai.
                </p>

                <b>Changes to Our Privacy Statement</b>
                <p>
                  Upstox may update its data privacy practices and revise this
                  privacy statement as needed, with the updated version posted
                  on our website. Nonetheless, our commitment to safeguarding
                  the privacy of website users will remain steadfast.
                </p>
              </div>
            </li>

            <li>
              <h3>
                Collection Of Sensitive Personal Data Or Information:
                <i class="fa fa-plus"></i>
              </h3>
              <div class="accordian-content" style="display: none">
                <p>
                  UPSTOX may for the purpose of rendering its services, collect
                  personal information such as:
                </p>
                <p>
                  Name, gender, residential / correspondence address, telephone
                  number, date of birth, marital status, email address or other
                  contact information; PAN, KYC Status, Signature and
                  Photograph; Bank account or other payment instrument details;
                  or any other detail for providing services.
                </p>
                <p>
                  Upstox is a comprehensive wealth platform offering a range of
                  financial services.To deliver these services, Upstox might
                  collect personal information which may be shared with
                  registered/authorised third parties and/or regulatory bodies
                  such as SEBI, IRDAI, Stock Exchanges (NSE/ BSE, MCX, MSEI),
                  BASL, AMFI, Mutual Fund AMCs, Registrar and Transfer Agents,
                  Collecting Banks, KYC Registration Agencies (KRAs), DigiLocker
                  and other regulatory bodies to facilitate seamless transaction
                  processing and compliance with applicable laws.
                </p>
                <p>
                  Under certain circumstances we may be required to share the
                  information given by you with the third parties, where we feel
                  they can contribute to add value and improve the quality of
                  services imparted by us to you. We shall take all reasonable
                  steps to ensure that the confidentiality of your information
                  is maintained by imposing strict confidentiality standards on
                  all the third parties with whom we part this information. In
                  all circumstances we shall ensure that your personal
                  information is protected by strict confidentiality agreement.
                  We shall not allow any third parties to retain your personal
                  information longer than what is warranted by the nature of
                  services rendered. We would also impart your personal
                  information wherever it is required to be disclosed under law
                  to any of the governmental agency or regulatory bodies. By
                  agreeing to avail the service offered by UPSTOX you have
                  agreed to the collection and use of your Sensitive Personal
                  Data or Information by UPSTOX. You always have the right to
                  refuse or withdraw your consent to share/dissemination of your
                  Sensitive Personal Data or Information by contacting the
                  customer care. However, in such an event, you would no longer
                  avail the services of UPSTOX.
                </p>
                <p>
                  Upstox reserves the right to carry out necessary due diligence
                  which may include sharing details with third party for
                  checking their creditworthiness.
                </p>
              </div>
            </li>

            <li>
              <h3>Links to other websites: <i class="fa fa-plus"></i></h3>
              <div class="accordian-content" style="display: none">
                <p>
                  Our website may contain links to other websites of interest.
                  However, once you have used these links to leave our site, you
                  should note that we do not have any control over that other
                  website. Therefore, we cannot be responsible for the
                  protection and privacy of any information which you provide
                  whilst visiting such sites and such sites are not governed by
                  this privacy statement. You should exercise caution and look
                  at the privacy statement applicable to the website in
                  question.
                </p>
              </div>
            </li>

            <li>
              <h3>
                Cookies and Tracking Technology: <i class="fa fa-plus"></i>
              </h3>
              <div class="accordian-content" style="display: none">
                <p>
                  provide whilst visiting such sites and such sites are not
                  governed by this privacy statement. You should exercise
                  caution and look at the privacy statement applicable to the
                  website in question.Cookies and Tracking Technology:A cookie
                  is a small data file that certain Web sites write to your hard
                  drive when you visit them. Cookies cannot be used to run
                  programs or deliver viruses to your computer. A cookie file
                  can contain information such as a user ID that the site uses
                  to track the pages you've visited, but the only personal
                  information a cookie can contain is information you supply
                  yourself. A cookie can't read data off your hard disk or read
                  cookie files created by other sites. Cookies save your time,
                  for example, if you personalize a web page, or navigate within
                  a Site; a cookie recalls your specific information on
                  subsequent visits. www.upstox.com also uses cookies to track
                  user traffic patterns. We do this in order to determine the
                  usefulness of our website information to our users and to see
                  how effective our navigational structure is in helping users
                  reach that information. You may accept or decline cookies.
                  Most web browsers automatically accept cookies; however you
                  can modify your browser setting to decline cookies. In
                  addition to cookies, our site uses a variety of technical
                  methods for tracking purposes, which may include web beacons.
                  Web beacons are small pieces of data that are embedded in
                  images on the pages of web sites. www.upstox.com also uses
                  these technical methods to analyze the traffic patterns on our
                  web site, such as the frequency with which our users visit
                  various parts of our web site.
                </p>
              </div>
            </li>
            <li>
              <h3>Use of Access Log Files: <i class="fa fa-plus"></i></h3>
              <div class="accordian-content" style="display: none">
                <p>
                  We gather and store certain information i.e. IP address,
                  browser type (e.g. Internet Explorer, Chrome, Firefox, Safari
                  etc.), the date and time of your visit and the pages on our
                  website number of pages viewed etc. in order to provide better
                  service for our users. We use the information to get page view
                  statistics, to analyze trends and better understand the usage
                  of the site, and for system administration purposes. This
                  information cannot and does not identify you personally.
                </p>
              </div>
            </li>
            <li>
              <h3>Communications: <i class="fa fa-plus"></i></h3>
              <div class="accordian-content" style="display: none">
                <p>
                  When You use the Website or send emails or other data,
                  information or communication to us, You agree and understand
                  that You are communicating with Us through electronic records
                  and You consent to receive communications via electronic
                  records from Us periodically and as and when required. We may
                  communicate with you by email or by such other mode of
                  communication, electronic or otherwise.
                </p>
              </div>
            </li>
            <li>
              <h3>Trademarks and Copyright: <i class="fa fa-plus"></i></h3>
              <div class="accordian-content" style="display: none">
                <p>
                  The content and information contained within our website or
                  the one delivered to you is the property of Upstox and any
                  other third party or partner (where applicable). The
                  trademark, trade names and logos that are used and displayed
                  on our website are proprietary to us and other third parties
                  or partners. Nothing on our website should be construed as
                  granting of any license or right to you to use any Trade
                  Marks, Trade Names and Logos displayed on our website. We
                  retain all proprietary rights on our website. Users are
                  prohibited from using the same without written permission of
                  Upstox or such other parties as deemed essential. Without the
                  prior written consent of Upstox no part of any materials on
                  our website may be modified, reproduced, copied, stored,
                  transmitted, distributed, used for creating works or used in
                  any other way for commercial or public purposes.
                </p>
              </div>
            </li>
            <li>
              <h3>Disclaimer as to loss: <i class="fa fa-plus"></i></h3>
              <div class="accordian-content" style="display: none">
                <p>
                  The information contained in this website is for general
                  information purposes only. The information is provided by
                  Upstox and while we endeavor to keep the information up to
                  date and correct, we make no representations or warranties of
                  any kind, express or implied, about the completeness,
                  accuracy, reliability, suitability or availability with
                  respect to the website or the information, products, services,
                  or related graphics contained on the website for any purpose.
                  Any reliance you place on such information is therefore
                  strictly at your own risk.
                </p>
                <p>
                  In no event will we be liable for any loss or damage including
                  without limitation, indirect or consequential loss or damage,
                  or any loss or damage whatsoever arising from loss of data or
                  profits arise out of, or in connection with, the use of this
                  website.
                </p>
                <p>
                  Through this website you are able to link to other websites
                  which are not under the control of Upstox. We have no control
                  over the nature, content and availability of those sites. The
                  inclusion of any links does not necessarily imply a
                  recommendation or endorse the views expressed within them.
                </p>
                <p>
                  Every effort is made to keep the website up and running
                  smoothly. However, Upstox takes no responsibility for, and
                  will not be liable for, the website being temporarily
                  unavailable due to technical issues beyond our control.
                </p>
              </div>
            </li>
            <li>
              <h3>
                Cancellation / Termination Policy: <i class="fa fa-plus"></i>
              </h3>
              <div class="accordian-content" style="display: none">
                <p>
                  Opening of a Trading and Demat account with us takes
                  approximately 12 hours to 24 hours. You may place the
                  cancellation request with our support team within 12 hours of
                  the submission of your application with us. On receipt of the
                  cancellation request, the account opening shall not be
                  proceeded with.
                </p>
              </div>
            </li>
            <li>
              <h3>Refund Policy: <i class="fa fa-plus"></i></h3>
              <div class="accordian-content" style="display: none">
                <p>
                  We have developed our trading platform keeping you into focus
                  and the trading platform is accessed through opening a Trading
                  and Demat Account with us at the most pocket friendly cost. We
                  have lakhs of satisfied customers across India and hence we
                  back our products. You may place a refund request with the
                  support team 07 days along with the payments details like the
                  Card / Bank Account Number, Transaction Number, etc. Refund
                  shall be provided only for any excess payment of account
                  opening charges made to us during application of your Trading
                  and Demat Account and confirmation from the banking partner
                  with respect to receipt of such payment from you. No refund of
                  account opening charges shall be made once the Trading and
                  Demat account is opened with us. Once your Trading and Demat
                  account is opened any payments made thereafter will be
                  credited towards your account and there shall be no refunds.
                  To withdraw any amount from such account you may place
                  withdrawal request through the App or the Web.
                </p>
              </div>
            </li>
            <li>
              <h3>BO Clause: <i class="fa fa-plus"></i></h3>
              <div class="accordian-content" style="display: none">
                <p>
                  We as a merchant shall be under no liability whatsoever in
                  respect of any loss or damage arising directly or indirectly
                  out of the decline of authorization for any Transaction, on
                  Account of the you (Payer / Cardholder) having exceeded the
                  preset limit mutually agreed by us with our acquiring bank
                  from time to time.
                </p>
              </div>
            </li>
            <li>
              <h3>
                Availability of Web-Site &amp; Data in Transit:
                <i class="fa fa-plus"></i>
              </h3>
              <div class="accordian-content" style="display: none">
                <p>
                  We do not warrant that the Site will be available at all times
                  and that access will not be interrupted, failures, errors or
                  omissions or loss of information during transmission. We also
                  do not warrant that no viruses or other contaminating will be
                  transmitted or that no damage will take place to your computer
                  system. You shall be solely responsible for adequate
                  protection and back up of your system and data. We make no
                  representations or warranties regarding the functionality or
                  performance of any third party software that may be used in
                  connection with the Site.
                </p>
              </div>
            </li>
            <li>
              <h3>Changes To Our Policy: <i class="fa fa-plus"></i></h3>
              <div class="accordian-content" style="display: none">
                <p>
                  Please note that this policy may change from time to time. If
                  UPSTOX change its policies and procedures, UPSTOX will post
                  those changes on UPSTOX website to keep you/users aware of
                  what information UPSTOX collect, how UPSTOX use it and under
                  w/terms-of-use-and-privacy-policy/hat circumstances UPSTOX may disclose it. Changes to this
                  Policy are effective when they are posted on this page. Please
                  visit our website to keep yourself abreast of any changes to
                  this policy.
                </p>
              </div>
            </li>
          </ol>
        </div>
        <!--/privacy-policy accrordian-->
      </div>
      <!--/container-->
    </section>
    <!--/privacy polocy-->
  </div>
</template>
<style scoped>
</style>
